import { render, staticRenderFns } from "./usermodal.vue?vue&type=template&id=24c476c8&scoped=true"
import script from "./usermodal.vue?vue&type=script&lang=js"
export * from "./usermodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c476c8",
  null
  
)

export default component.exports